// Runtime startup guard, not a substitute for the pinned production release
// validator. Importing Supabase with an empty URL throws before React mounts.
export function hasFrontendConfiguration(url, key) {
  if (typeof url !== 'string' || url !== url.trim() ||
      typeof key !== 'string' || !key.trim() || key !== key.trim()) return false
  try {
    const target = new URL(url)
    const local = ['localhost', '127.0.0.1', '[::1]'].includes(target.hostname)
    return (target.protocol === 'https:' || (target.protocol === 'http:' && local)) &&
      !target.username && !target.password && !target.search && !target.hash
  } catch {
    return false
  }
}

/**
 * @param {{url: unknown, key: unknown, load: () => Promise<void>,
 *   unavailable: (kind: 'configuration' | 'loading') => void}} options
 */
export async function startConfiguredApplication({ url, key, load, unavailable }) {
  if (!hasFrontendConfiguration(url, key)) {
    unavailable('configuration')
    return
  }
  try {
    await load()
  } catch {
    unavailable('loading')
  }
}
